import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width||44}
    height={props.width||44}
    viewBox="0 0 44 44"
    fill="none"
    {...props}
  >
    <path
      fill="#1F4CC8"
      d="M22.088 43.721c-12.047 0-21.85-9.804-21.85-21.85C.237 9.823 10.04.02 22.087.02s21.85 9.804 21.85 21.85c0 12.047-9.803 21.851-21.85 21.851Z"
    />
    <path
      fill="#48DFB9"
      d="M36.125 20.444 14.891 8.19c-1.092-.632-2.466.156-2.466 1.426v24.51a1.646 1.646 0 0 0 2.466 1.425l21.227-12.255c1.092-.63 1.092-2.213 0-2.844l.007-.008Z"
    />
  </svg>
)
export default SvgComponent
